import { Box } from '@factorialco/deprecated-design-system'
import type { BillingAddonReferenceFragment } from 'generated/resources/graphql'

import { PlanComparisonContent } from 'modules/marketplace_modules/components/Revamp/PricingPlan/_Modal'
import { useComparisonPlansFromSelfUpsell } from 'modules/marketplace_modules/hooks/useComparisonPlansFromSelfUpsell'
import { SelfUpsellProvider } from 'modules/upsell/store/SelfUpsellProvider'

interface PlansTabProps {
  billingAddonReference: readonly BillingAddonReferenceFragment[]
  moduleRequested: string
}

const PlansTabWithSelfUpsell = () => {
  const plans = useComparisonPlansFromSelfUpsell()
  return <PlanComparisonContent plans={plans} />
}

export const PlansTab = ({ billingAddonReference, moduleRequested }: PlansTabProps) => (
  <Box
    paddingY="s16"
    paddingLeft="s16"
    paddingRight="s16"
    style={{
      width: '100%',
      minWidth: '0',
      flex: '1',
      minHeight: '0',
      overflow: 'auto',
    }}
  >
    {billingAddonReference.length > 0 ? (
      <SelfUpsellProvider
        availableAddons={billingAddonReference}
        availableCrossSellingAddons={[]}
        availableMandatoryCrossSellingAddons={[]}
        moduleName={moduleRequested}
      >
        <PlansTabWithSelfUpsell />
      </SelfUpsellProvider>
    ) : (
      <PlanComparisonContent plans={[]} />
    )}
  </Box>
)
